<template>
  <v-chip :class="didSearch ? 'active' : ''" @click:close="$emit('close', cmpData.key)" :close="cmpData.closable" close-icon="$sl-close">
    <v-icon small class="mr-2">$sl-search</v-icon>{{text}}
  </v-chip>
</template>

<script>
export default {

  props: {
    // The v-model value
    cmpData: {
      type: Object,
    },
    didSearch: {
      type: Boolean,
    }
  },
  computed: {
    text() {
      const values = [this.cmpData.chipLabel];
      if(typeof this.cmpData.value !== 'boolean'){
        values.push(this.cmpData.value)
      }

      return values.join(': ')
    }
  }
}
</script>

<style scoped>
  .active {
    background-color: var(--v-onPrimary-base) !important;
  }

</style>